<template>
  <div>
    <div>
      <div class="vx-col sm:w-1/1 w-full mb-6">
        <div v-if="isLoadingSendConfigs" class="text-grey mb-4">
          Carregando configurações de envio...
        </div>
        <vx-card
          class="mb-6"
          v-for="(item, index) in integrations"
          :key="item.id || index"
        >
          <div>
            <div class="flex items-start justify-between flex-wrap">
              <div class="mb-4">
                <h3>{{ item.integration }}</h3>
                <h5>Envio de apólices p/ {{ item.integration }}</h5>
              </div>
              <span v-if="isSavingIntegration(item.id)" class="text-grey">
                Salvando...
              </span>
            </div>
            <div class="vx-row mb-6">
              <div
                :class="isI4ProIntegration(item) ? 'vx-col sm:w-1/5 w-full mt-6' : 'vx-col sm:w-1/4 w-full mt-6'"
              >
                <span>Vida</span>
                <vs-switch
                  v-model="integrations[index].sendPolicyLife"
                  :disabled="isIntegrationBusy(item.id)"
                  color="success"
                  style="width: 80px"
                >
                  <span slot="on">Enviar</span>
                  <span slot="off">Não enviar</span>
                </vs-switch>
              </div>
              <div
                :class="isI4ProIntegration(item) ? 'vx-col sm:w-1/5 w-full mt-6' : 'vx-col sm:w-1/4 w-full mt-6'"
              >
                <span>Microvida</span>
                <vs-switch
                  v-model="integrations[index].sendPolicyMicroLife"
                  :disabled="isIntegrationBusy(item.id)"
                  color="success"
                  style="width: 80px"
                >
                  <span slot="on">Enviar</span>
                  <span slot="off">Não enviar</span>
                </vs-switch>
              </div>
              <div
                :class="isI4ProIntegration(item) ? 'vx-col sm:w-1/5 w-full mt-6' : 'vx-col sm:w-1/4 w-full mt-6'"
              >
                <span>Auto</span>
                <vs-switch
                  v-model="integrations[index].sendPolicyAuto"
                  :disabled="isIntegrationBusy(item.id)"
                  color="success"
                  style="width: 80px"
                  :data-testid="isI4ProIntegration(item) ? 'i4pro-send-policy-auto' : null"
                >
                  <span slot="on">Enviar</span>
                  <span slot="off">Não enviar</span>
                </vs-switch>
              </div>
              <div
                v-if="isI4ProIntegration(item)"
                class="vx-col sm:w-2/5 w-full mt-6"
              >
                <label class="vs-select--label">Corretoras enviadas ao I4PRO</label>
                <v-select
                  v-model="integrations[index].i4proBrokerSelection"
                  class="w-full"
                  :options="i4ProBrokerOptions"
                  multiple
                  clearable
                  :closeOnSelect="false"
                  :disabled="
                    !item.sendPolicyAuto ||
                    isIntegrationBusy(item.id) ||
                    isLoadingBrokers
                  "
                  label="label"
                  :reduce="(option) => option.id"
                  :placeholder="isLoadingBrokers ? 'Carregando corretoras...' : 'Selecione as corretoras'"
                  @input="handleI4ProBrokerSelection(item, $event)"
                  data-testid="i4pro-send-policy-auto-broker-ids"
                ></v-select>
                <p
                  class="text-sm mt-2"
                  :class="hasI4ProBrokerWarning(item) ? 'text-warning' : 'text-grey'"
                >
                  {{ getI4ProBrokerHelpText(item) }}
                </p>
              </div>
            </div>
            <div class="w-full flex justify-end">
              <vs-button
                @click="updateSendConfigs(integrations[index])"
                color="success"
                :disabled="isIntegrationBusy(item.id)"
                :data-testid="isI4ProIntegration(item) ? 'save-i4pro-send-config' : null"
              >
                {{ isSavingIntegration(item.id) ? 'Salvando...' : 'Salvar Alterações' }}
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-6" v-for="item in integracoes" :key="item.id">
      <div class="vx-col sm:w-1/1 w-full">
        <vx-card>
          <h3>{{ item.nomeFornecedor }}</h3>
          <div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-4">
                <formIntegracao :objUpdate="item" @concluido="buscaDados()" />
              </div>
              <div v-if="item.possuiDePara" class="vx-col sm:w-2/3 w-full mt-4">
                <button
                  class="vs-component vs-button vs-button-primary vs-button-gradient"
                  @click="openDePara(item)"
                  type="gradient"
                >
                  De/Para
                </button>
                <formIntegracaoDePara
                  :objUpdate="item.dePara"
                  :objGeral="item"
                  @concluido="openDePara(item)"
                />
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import service from './../../../services';
import locale from './../../../locale';
import formIntegracao from './../../forms/formIntegracao.vue';
import formIntegracaoDePara from './../../forms/formIntegracaoDePara.vue';
import notify from '../../../utils/notify';
import integrationApiService from '../../../services/integration.api';
import autoApi from '../../../services/auto.api';
import vSelect from 'vue-select';

const ALL_BROKERS_OPTION_ID = -1;

export default {
  name: 'ConfiguracoesIntegracoes',
  components: {
    'v-select': vSelect,
    formIntegracao,
    formIntegracaoDePara,
  },
  computed: {
    i4ProBrokerOptions() {
      return [
        { id: ALL_BROKERS_OPTION_ID, label: 'Todas as corretoras' },
        ...this.brokers,
      ];
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      integracoes: [],
      form: {},
      passo: 0,
      controller: 'integrations',
      action: 'sendconfigs',
      integrations: [],
      brokers: [],
      isLoadingSendConfigs: false,
      isLoadingBrokers: false,
      savingIntegrationIds: [],
    };
  },
  methods: {
    normalizeIntegrationSendConfig(config) {
      const sendPolicyAutoBrokerIds = Array.isArray(config.sendPolicyAutoBrokerIds)
        ? config.sendPolicyAutoBrokerIds
            .map((brokerId) => Number(brokerId))
            .filter((brokerId) => !Number.isNaN(brokerId))
        : [];
      const sendPolicyAutoAllBrokers = !!config.sendPolicyAutoAllBrokers;

      return {
        ...config,
        sendPolicyLife: !!config.sendPolicyLife,
        sendPolicyMicroLife: !!config.sendPolicyMicroLife,
        sendPolicyAuto: !!config.sendPolicyAuto,
        sendPolicyAutoAllBrokers,
        sendPolicyAutoBrokerIds,
        i4proBrokerSelection: sendPolicyAutoAllBrokers
          ? [ALL_BROKERS_OPTION_ID]
          : sendPolicyAutoBrokerIds,
      };
    },
    normalizeBrokerOptions(brokers) {
      if (!Array.isArray(brokers)) {
        return [];
      }

      return brokers
        .map((broker) => ({
          ...broker,
          id: Number(broker.id || broker.idDivisao || broker.brokerId),
          label: broker.label || broker.nomeDivisao || broker.nome || broker.name,
        }))
        .filter((broker) => !Number.isNaN(broker.id) && broker.label)
        .sort((firstBroker, secondBroker) =>
          firstBroker.label.localeCompare(secondBroker.label),
        );
    },
    isI4ProIntegration(integration) {
      return String(integration.integration || '').toUpperCase() === 'I4PRO';
    },
    isSavingIntegration(integrationId) {
      return this.savingIntegrationIds.includes(integrationId);
    },
    isIntegrationBusy(integrationId) {
      return this.isLoadingSendConfigs || this.isSavingIntegration(integrationId);
    },
    setSavingIntegration(integrationId, isSaving) {
      if (isSaving && !this.savingIntegrationIds.includes(integrationId)) {
        this.savingIntegrationIds.push(integrationId);
        return;
      }

      if (!isSaving) {
        this.savingIntegrationIds = this.savingIntegrationIds.filter(
          (id) => id !== integrationId,
        );
      }
    },
    getI4ProBrokerHelpText(integration) {
      if (!integration.sendPolicyAuto) {
        return 'Envio AUTO desabilitado. Nesse modo, toda emissão AUTO permanece no STAR.';
      }

      if (integration.sendPolicyAutoAllBrokers) {
        return 'Modo "Todas as corretoras" ativo. O salvamento será enviado com prioridade total para o I4PRO.';
      }

      if (this.isLoadingBrokers) {
        return 'Carregando corretoras disponíveis para roteamento.';
      }

      if (!this.brokers.length) {
        return 'Nenhuma corretora disponível para seleção manual no momento.';
      }

      if (!integration.sendPolicyAutoBrokerIds.length) {
        return 'Nenhuma corretora selecionada. Assim, nenhuma corretora será enviada ao I4PRO.';
      }

      return 'Somente as corretoras selecionadas serão enviadas ao I4PRO. As demais serão emitidas pelo STAR.';
    },
    handleI4ProBrokerSelection(integration, selection) {
      const normalizedSelection = Array.isArray(selection)
        ? selection
            .map((brokerId) => Number(brokerId))
            .filter((brokerId) => !Number.isNaN(brokerId))
        : [];
      const hasAllOption = normalizedSelection.includes(ALL_BROKERS_OPTION_ID);

      if (hasAllOption) {
        if (integration.sendPolicyAutoAllBrokers) {
          const manualSelection = normalizedSelection.filter(
            (brokerId) => brokerId !== ALL_BROKERS_OPTION_ID,
          );

          integration.sendPolicyAutoAllBrokers = false;
          integration.sendPolicyAutoBrokerIds = manualSelection;
          integration.i4proBrokerSelection = manualSelection;
          return;
        }

        integration.sendPolicyAutoAllBrokers = true;
        integration.sendPolicyAutoBrokerIds = [];
        integration.i4proBrokerSelection = [ALL_BROKERS_OPTION_ID];
        return;
      }

      integration.sendPolicyAutoAllBrokers = false;
      integration.sendPolicyAutoBrokerIds = normalizedSelection;
      integration.i4proBrokerSelection = normalizedSelection;
    },
    hasI4ProBrokerWarning(integration) {
      return (
        integration.sendPolicyAuto &&
        !integration.sendPolicyAutoAllBrokers &&
        !this.isLoadingBrokers &&
        (!this.brokers.length || !integration.sendPolicyAutoBrokerIds.length)
      );
    },
    buildUpdatePayload(integration) {
      const payload = {
        id: integration.id,
        integration: integration.integration,
        sendPolicyLife: !!integration.sendPolicyLife,
        sendPolicyMicroLife: !!integration.sendPolicyMicroLife,
        sendPolicyAuto: !!integration.sendPolicyAuto,
      };

      if (!this.isI4ProIntegration(integration)) {
        return payload;
      }

      const sendPolicyAutoAllBrokers =
        payload.sendPolicyAuto && !!integration.sendPolicyAutoAllBrokers;

      return {
        ...payload,
        sendPolicyAutoAllBrokers,
        sendPolicyAutoBrokerIds:
          payload.sendPolicyAuto && !sendPolicyAutoAllBrokers
            ? integration.sendPolicyAutoBrokerIds
            : [],
      };
    },
    async fetchSendConfigs() {
      try {
        const response = await integrationApiService.getAllSendConfigs();
        this.integrations = Array.isArray(response)
          ? response.map(this.normalizeIntegrationSendConfig)
          : [];
      } catch (error) {
        this.integrations = [];
        notify.notifyFail(this.$vs, 'Erro ao buscar configurações de envio');
      }
    },
    async fetchBrokers() {
      try {
        const response = await autoApi.getBrokersList();
        this.brokers = this.normalizeBrokerOptions(response);
      } catch (error) {
        this.brokers = [];
        notify.notifyFail(this.$vs, 'Erro ao buscar as corretoras');
      }
    },
    async loadSendConfigsContext() {
      this.isLoadingSendConfigs = true;
      this.isLoadingBrokers = true;
      try {
        await Promise.all([this.fetchSendConfigs(), this.fetchBrokers()]);
      } finally {
        this.isLoadingSendConfigs = false;
        this.isLoadingBrokers = false;
      }
    },
    async updateSendConfigs(data) {
      const payload = this.buildUpdatePayload(data);
      this.setSavingIntegration(data.id, true);
      try {
        await integrationApiService.updateSendConfigs(payload);
        Object.assign(data, this.normalizeIntegrationSendConfig(payload));
        notify.notifySuccess(this.$vs, 'Dados atualizados!');
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao atualizar configurações de envio');
      } finally {
        this.setSavingIntegration(data.id, false);
      }
    },
    openDePara(item) {
      this.aguardeCadastro = true;
      this.$vs.loading();
      service
        .post('integracoes', 'buscaDePara', item)
        .then((res) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          item.dePara = res.data;
          this.$forceUpdate();
        })
        .catch((error) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
    onSubmit() {
      this.form.dadosProposta = this.dadosProposta;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.$vs.loading();
          service
            .post('Cotacao', 'AtualizarPropostaGeral', this.form)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    preencheForm() {},
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idEmpresa = this.idEmpresa;
      objSend.notDeleted = true;
      service
        .post('integracoes', 'list', objSend)
        .then((res) => {
          this.integracoes = [];
          if (res.data.length > 0) {
            res.data.forEach((element) => {
              if (element.jsonFacilitador) {
                element.jsonFacilitador = JSON.parse(element.jsonFacilitador);
                element.parametros = element.parametros
                  ? JSON.parse(element.parametros)
                  : {};
                this.integracoes.push(element);
              }
            });
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },

    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.buscaDados();
    this.loadSendConfigsContext();
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}
.forceWhite:hover {
  color: #fff !important;
}

</style>
